require('../../fhApp/currentUser/currentUser');
require('../../shared/singleGameService');
require('../../shared/dataTransformers/clipTransformer');

'use strict';

angular.module('app.shared.userFeed.userFeedService', [
  'app.currentUser',
  'app.shared.singleGameService',
  'app.shared.dataTransformers.clipTransformer'
])
  .factory('app.shared.userFeed.userFeedService', [
    '$http', 'currentUser', '$rootScope', '$q', '$timeout',
    '$httpParamSerializerJQLike', 'app.shared.singleGameService',
    'app.shared.dataTransformers.clipTransformer',
    function ($http, currentUser, $rootScope, $q, $timeout, $httpParamSerializerJQLike, singleGame, clipTransformer) {
      return {
        "new": function () {
          let feed = {
            user_id: null,
            user: null,
            items: null,
            count: 0,
            error: null,
            _debounceRetrieve: _.debounce((deferred, user_id, type, params) => {
              if (user_id) {
                feed.user_id = user_id;
              }
              if (feed.user_id) {
                let processResponse = response => {
                  let data = response.data;

                  if (data.feed) {
                    feed.items = _.forEach(data.feed, function (item) {
                      if (item.game && item.game.dtegametimefixed) {
                        let gameTime = moment(item.game.dtegametimefixed);

                        item.game.gametimeday = gameTime.format('ddd');
                        item.game.dtegametimefixed = gameTime.toDate();
                      }

                      if(item.sort_date) {
                        item.sort_date = moment(item.sort_date).toDate();
                      }

                      if (item.iclipid) {
                        item = clipTransformer.transformToUi(item);
                      }

                      if (item.igameid) {
                        item = singleGame.transform(item);
                      }

                      return item;
                    });

                    //feed.count = data.feed.count;
                  }
                  if (data.user) {
                    feed.user = data.user;
                  }
                  if (data.error) {
                    feed.error = data.error;
                  }
                  $rootScope.$broadcast('user_feed_changed', {
                    user_id: user_id
                  });
                };

                feed.error = null;
                params = $httpParamSerializerJQLike(params);
                $http.get(
                  window.location.api('users/' + feed.user_id + '/feed' + (type ? '/' + type : '') + '?' + params),
                  {
                    timeout: deferred.promise
                  }
                )
                  .then(response => {
                    processResponse(response);
                  })
                  .catch(response => {
                    processResponse(response);
                  });
              }
            }, 300),
            retrieve: (user_id, type, params) => {
              let deferred = $q.defer();

              feed._debounceRetrieve(deferred, user_id, type, params);

              return deferred.promise;
            },
            title: function () {
              if (feed.user) {
                if (feed.user.iuserid === currentUser.data.iuserid) {
                  return "My Feed";
                } else {
                  return feed.user.first_name + "'s Feed";
                }
              }
              return "User Feed";
            }
          };

          return feed;
        }
      };
    }
  ]);


// WEBPACK FOOTER //
// ./app.v2/components/shared/userFeed/userFeedService.js